export default Object.freeze({
    FULL_DATETIME: 'DD/MM/YYYY HH:mm:ss',
    'YEAR-MONTHS-DAYS': 'YYYY-MM-DD',
    'DAYS.MONTHS.YEARS_HOURS:MINUTES:SECONDS': 'DD.MM.YYYY, HH:mm:ss'
});
